import textStyle from './xAxis.data.textStyle'

export default {
  name: "data",
  nickname: "数据",
  desc:
    '类目数据，在类目轴（<a target="__blank" href="https://echarts.apache.org/zh/option.html#xAxis.type">type</a>: <code class="codespan">&#39;category&#39;</code>）中有效。',
  type: "array",
  props: {
    value: {
      name: "value",
      nickname: "值",
      desc: "单个类目名称。",
      type: "pureValue",
    },
    textStyle,
  },
}
